<section style="height: 90%">
  <h1>Rendimiento</h1>
  <app-player-selector (playerSelected)="onPlayerSelected($event)">
    <app-player-stats [player]="player"></app-player-stats>
    <!-- <img style="margin-top: 6em; width: 30em;" src="assets/static/images/under-construct.webp"> -->
  </app-player-selector>
</section>
